export async function apiRequest<T>(
  path: string,
  options: RequestInit = {},
  csrfToken: string | null = null
): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }
  if (csrfToken && options.method && options.method !== "GET") {
    headers.set("x-csrf-token", csrfToken);
  }

  const response = await fetch(path, {
    ...options,
    headers,
    credentials: "include"
  });
  const responseText = await response.text();
  let payload = {} as T & { error?: string };
  try {
    payload = responseText ? JSON.parse(responseText) as T & { error?: string } : payload;
  } catch {
    const isHtmlError = /<!doctype html|<html|worker threw exception/i.test(responseText);
    payload = { error: isHtmlError ? `Request failed with HTTP ${response.status}` : responseText || `HTTP ${response.status}` } as T & { error?: string };
  }
  if (!response.ok) {
    throw new Error(payload.error || `Request failed with HTTP ${response.status}`);
  }
  return payload;
}
